export const webComponentRefreshConstants = {
    WEB_MAP_REFRESH_PENDING: 'WEB_MAP_REFRESH_PENDING',
    WEB_MAP_REFRESH_FULFILLED: 'WEB_MAP_REFRESH_FULFILLED',
    WEB_MAP_REFRESH_REJECTED: 'WEB_MAP_REFRESH_REJECTED',

    WEB_REVIEW_REFRESH_PENDING: 'WEB_REVIEW_REFRESH_PENDING',
    WEB_REVIEW_REFRESH_FULFILLED: 'WEB_REVIEW_REFRESH_FULFILLED',
    WEB_REVIEW_REFRESH_REJECTED: 'WEB_REVIEW_REFRESH_REJECTED',

    WEB_COMPONENT_REFRESH_CLEAR: 'WEB_COMPONENT_REFRESH_CLEAR',
};
